import makeStyles from '@material-ui/styles/makeStyles';
import { PropsColors } from '../../Context/colorContext';
import theme from '../../services/theme-service';

export const useStyles = makeStyles({
  main: ({ colors }: PropsColors) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.colorBackground,
    borderTop: `1px solid ${colors.colorBackgroundFooter}`,
  }),
  link: {
    display: 'flex',
  },
  icon: ({ colors }: PropsColors) => ({
    color: colors.accentColor,
    width: 24,
    height: 24,
    cursor: 'pointer',
  }),
  formSearch: {},
  inputSearch: ({ colors }: PropsColors) => ({
    height: 50,
    borderRadius: 0,
    fontFamily: 'Open sans',
    width: '100%',
    border: 'none',
    outline: 'none',
    paddingLeft: 16,
    color: colors.textBody,
    background: colors.serviceCardBackgroundColor,
    '&::placeholder': {
      color: '#888888',
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
    },
  }),
  buttonSearch: ({ colors }) => ({
    background: colors.serviceCardBackgroundColor,
    '&:hover': {
      background: colors.breadcrumbButtonColorHover,
    },
  }),
  breadcrumbs: ({ colors }) => ({
    flexGrow: 1,
    color: colors.accentColor,
    [theme.breakpoints.down('md')]: {
      padding: '15px 16px 0px 16px',
    },
  }),
  breadcrumbLi: {
    display: 'flex',
  },
  itemBreadcrumb: ({ colors }) => ({
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    color: colors.textBody,
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: 350,
  }),
  iconSearch: ({ colors }) => ({
    color: colors.accentColor,
  }),
});
